import styled from "@emotion/styled"
import { Container, IconButton, Typography } from "@mui/material"
import CustomLink from "../custom-link/custom-link.component"
import CustomImage from "../custom-image/custom-image.component"

export const FooterSection = styled.footer`
  color: white;
  padding-top: ${({ theme }) => theme.typography.pxToRem(64)};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(24)};
  background-color: ${({ theme }) => theme.palette.secondary.dark};
  overflow: hidden;
`

export const Wrapper = styled(Container)`
  svg {
    height: 32px;
    ${({ theme }) => theme.breakpoints.up("sm")} {
      height: 48px;
    }
  }
`

export const BottomContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.typography.pxToRem(40)};
  margin-top: ${({ theme }) => theme.typography.pxToRem(98)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: ${({ theme }) => theme.typography.pxToRem(36)};
  }
`

export const Link = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.5;

  &.item {
    opacity: 1;
    line-height: ${({ theme }) => theme.typography.pxToRem(26)};
    text-transform: capitalize;
  }

  &:hover {
    text-decoration: underline;
  }
`

export const Copyright = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.5;
`

export const Image = styled(CustomImage)`
  width: 196.849px;
  height: 48px;
`

export const Description = styled(Typography)`
  max-width: 542px;
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.5;
  margin-top: ${({ theme }) => theme.typography.pxToRem(32)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(24)};
    margin-top: 1.5rem;
  }
`

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: 1px;
  opacity: 0.4;
  margin-bottom: 1rem;
  &.social {
    margin-top: 1rem;
  }
  ${({ theme }) => theme.breakpoints.up("sm")} {
    &.social {
      margin-top: 0;
    }
    margin-bottom: 1.5rem;
  }
`
export const SocialContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
`

export const SocialButton = styled(IconButton)`
  border-radius: 50px;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.05);

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`
